import { createUseStyles } from "react-jss";
import { theme } from "$utils/theme/bataillog";

export const useStyles = createUseStyles({
  wrapper: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
  },
  popinContainer: {
    display: "flex",
    flex: 1,
  },
  inputContainer: {
    display: "flex",
    flex: 1,
    alignItems: "flex-end",
  },
  lineContainer: {
    display: "flex",
    padding: `${theme.spacing(2)}px 0`,
  },
  addButtonContainer: {
    width: 30,
    marginLeft: theme.spacing(2),
    alignSelf: "flex-end",
    height: 32,
  },
  addButton: {
    maxWidth: 30,
    minWidth: `30px !important`,
    padding: `${theme.spacing(1)}px !important`,
    height: "100%",
  },
  buttonsContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: theme.spacing(4),
  },
  errorField: {
    color: theme.color.red,
    fontSize: 12,
  },
});
